import { createFormContext } from '@mantine/form'
import { AuthenticationFormValues } from 'components/business/Authentication'

export interface PasswordResetFormValues extends AuthenticationFormValues {}

export const [PasswordResetFormProvider, usePasswordResetFormContext, usePasswordResetForm] =
  createFormContext<PasswordResetFormValues>()
